/**
 * Get the current user ID from localStorage auth data.
 * Shared across maintenance hooks (auto-save, state preservation).
 */
export function getUserId(): string | null {
  try {
    const raw = localStorage.getItem("seweb_auth");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed.user?.id ?? parsed.userId ?? null;
  } catch {
    return null;
  }
}
